import React from 'react';

import { t } from 'i18next';
import LeadsPrivateRoute from 'pages/leads/components/leads-private-route/leads-private-route';
import CreatePassword from 'pages/leads/pages/create-password';
import Requisites from 'pages/leads/pages/requisites';
import Revenues from 'pages/leads/pages/revenues';
import Segments from 'pages/leads/pages/segments';
import Unqualified from 'pages/leads/pages/unqualified';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import { Header } from '../components/layout';
import BannerWrapper from '../components/layout/banner-wrapper/banner-wrapper';
import LoadingOlist from '../components/layout/loading-olist';
import PageLayout from '../components/layout/page-layout';
import PageLayoutNoSupport from '../components/layout/page-layout-no-support';
import BankAccountPage from '../pages/bank-account';
import InternalServerErrorPage from '../pages/errors/internal-server-error';
import NotFoundPage from '../pages/errors/not-found';
import OnboardingPage from '../pages/onboarding';
import PersonalInformationPage from '../pages/personal-information';
import PlanChoice from '../pages/plan-choice';
import PlanPresentation from '../pages/plan-presentation';
import TermsOfService from '../pages/terms-of-service';
import * as URLS from '../utils/urls';
import PrivateRoute from './private-route';

document.title = `${t`first steps`} - Olist`;

function HeaderRender() {
  if (
    window.location.href.includes(URLS.ONBOARDING_BASE_URL) ||
    window.location.href.includes(URLS.SUBSCRIPTION_BASE_URL)
  ) {
    return <Header />;
  }

  return <></>;
}

const DefaultRoutes = () => (
  <Switch>
    <Route path={URLS.ERROR_URL}>
      <InternalServerErrorPage />
    </Route>
    <Route path="*">
      <NotFoundPage />
    </Route>
  </Switch>
);

const SubscriptionRoutes = () => {
  return (
    <Switch>
      <PrivateRoute path={URLS.SUBSCRIPTION_PLAN_CHOICE_URL} exact>
        <PageLayout>
          <PlanChoice />
        </PageLayout>
      </PrivateRoute>
      <PrivateRoute path={URLS.SUBSCRIPTION_PLAN_CHOICE_URL_NEW} exact>
        <PageLayout>
          <PlanChoice />
        </PageLayout>
      </PrivateRoute>
      <DefaultRoutes />
    </Switch>
  );
};

const SetupRoutes = () => (
  <Switch>
    <LeadsPrivateRoute path={URLS.REQUISITES_URL}>
      <BannerWrapper>
        <Requisites />
      </BannerWrapper>
    </LeadsPrivateRoute>
    <LeadsPrivateRoute path={URLS.WELCOME_URL}>
      <BannerWrapper>
        <Requisites />
      </BannerWrapper>
    </LeadsPrivateRoute>
    <LeadsPrivateRoute path={URLS.REVENUES_URL}>
      <BannerWrapper>
        <Revenues />
      </BannerWrapper>
    </LeadsPrivateRoute>
    <LeadsPrivateRoute path={URLS.CATEGORIES_URL}>
      <BannerWrapper>
        <Segments />
      </BannerWrapper>
    </LeadsPrivateRoute>
    <LeadsPrivateRoute path={URLS.UNQUALIFIED_URL}>
      <BannerWrapper>
        <Unqualified />
      </BannerWrapper>
    </LeadsPrivateRoute>
    <LeadsPrivateRoute path={URLS.CREATE_PASSWORD_URL}>
      <BannerWrapper>
        <CreatePassword />
      </BannerWrapper>
    </LeadsPrivateRoute>
  </Switch>
);

const OnboardingRoutes = () => {
  return (
    <Switch>
      <PrivateRoute path={['/', URLS.ONBOARDING_BASE_URL, URLS.ONBOARDING_FIRST_STEPS_URL]} exact>
        <PageLayout>
          <OnboardingPage />
        </PageLayout>
      </PrivateRoute>
      <PrivateRoute path={URLS.ONBOARDING_PLAN_PRESENTATION_URL} exact>
        <PageLayout>
          <PlanPresentation />
        </PageLayout>
      </PrivateRoute>
      <PrivateRoute
        path={[
          URLS.PERSONAL_INFORMATION_URL,
          URLS.LOGISTIC_ADDRESS_URL,
          URLS.COMPANY_INFORMATION_URL,
          URLS.LIABLE_PARTNER_URL,
        ]}
        exact
      >
        <PageLayout>
          <PersonalInformationPage />
        </PageLayout>
      </PrivateRoute>
      <PrivateRoute path={URLS.SETTINGS_BANK_ACCOUNT_URL} exact>
        <PageLayout>
          <BankAccountPage />
        </PageLayout>
      </PrivateRoute>
      <DefaultRoutes />
    </Switch>
  );
};

const TermsOfServiceRoutes = () => (
  <PrivateRoute path={URLS.TERMS_OF_SERVICE_URL} exact>
    <PageLayoutNoSupport>
      <TermsOfService />
    </PageLayoutNoSupport>
  </PrivateRoute>
);

const Routes = () => (
  <React.Suspense fallback={LoadingOlist}>
    <HeaderRender />
    <Router>
      <Switch>
        <Route path={URLS.SUBSCRIPTION_BASE_URL} component={SubscriptionRoutes} />
        <Route path={URLS.SETUP_BASE_URL} component={SetupRoutes} />
        <Route path={URLS.TERMS_OF_SERVICE_URL} component={TermsOfServiceRoutes} />
        <Route
          path={['/', URLS.ONBOARDING_BASE_URL, URLS.ONBOARDING_FIRST_STEPS_URL]}
          component={OnboardingRoutes}
        />
        <DefaultRoutes />
      </Switch>
    </Router>
  </React.Suspense>
);

export default Routes;
